/* state/lazy-layer-data.js — hämta ett overlays data först när det tänds.
 *
 * Bakgrund (mätt 2026-07-22): sex overlays som alla är default AV fetchade
 * sin geojson direkt i setupX(map). En vanlig sidladdning av /karta drog
 * därför ner 13,4 MB data för lager ingen bett om:
 *
 *   skyddsrum.geojson          10,0 MB
 *   vindkraftverk.geojson       2,2 MB
 *   elcentraler.geojson         656 KB
 *   sweref_zoner.geojson        535 KB
 *   natkapacitet_lan.geojson    167 KB
 *   swepos_stationer.geojson    101 KB
 *
 * ui/layers-toggle.js emittar 'layer-vis-changed' med lager-ID:n både vid
 * init (LS-återställt läge) och vid varje kryssruta — så en modul som
 * registrerar sig här får sitt data om lagret redan var påslaget, och
 * annars först när användaren tänder det. Deep-links (?lager=, delad vy)
 * klickar kryssrutan och går därför genom samma väg.
 *
 * Anropas EN gång per modul, i stället för det gamla `loadData(map)` i setup.
 */

import { on } from '../bus.js';

/**
 * @param {string[]} layerIds  lagren som utlöser hämtningen (modulens egna)
 * @param {() => any} load     modulens loadData — måste vara idempotent
 */
/**
 * Misslyckad hämtning: kör `igen` efter 3 s, 6 s, 12 s … högst 60 s.
 * `igen` kollar själv om lagret fortfarande är på. Så en 429 i startrusningen
 * läker utan att användaren tänder om lagret eller laddar om sidan.
 * ponytail: räknaren nollas aldrig; ett lager som föll ofta får längre paus.
 */
const forsok = new Map();
export function forsokIgen(nyckel, igen) {
    const n = forsok.get(nyckel) || 0;
    forsok.set(nyckel, n + 1);
    setTimeout(igen, Math.min(3000 * 2 ** n, 60000));
}

/**
 * fetch() som tål startrusningens 429/5xx och nätblink: tre försök till,
 * efter 3, 6 och 12 s. Samma promise levererar till slut datat, så en
 * konsument som bara awaitar load() ritar rätt utan eget event. 404 är
 * permanent och går rakt igenom.
 */
export async function fetchMedOmforsok(url, init) {
    for (let n = 0; ; n++) {
        try {
            const r = await fetch(url, init);
            if (r.ok || r.status === 404 || n === 3) return r;
        } catch (err) {
            if (n === 3) throw err;
        }
        await new Promise((ok) => setTimeout(ok, 3000 * 2 ** n));
    }
}

export function loadWhenVisible(layerIds, load) {
    const want = new Set(layerIds);
    on('layer-vis-changed', ({ layers, visible }) => {
        if (!visible || !layers) return;
        if (layers.some((id) => want.has(id))) load();
    });
}
